<template>
    <div class="py-3 px-5 error lighten-2 rounded-lg mb-4 body-2">
        {{ $t('Company settings edit is disabled by owner') }}
    </div>
</template>

<script>
import { $t } from "@/i18n";

export default {
    name: "CompanySettingsDisabledWarning",
    setup(props, ctx) {
        return {
        };
    }
};
</script>
